import { Instagram, Facebook, Youtube } from "lucide-react";

// TikTok icon (no incluido en lucide-react)
const TikTokIcon = ({ className = "" }) => (
    <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        className={className}
        aria-hidden="true"
    >
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.1z" />
    </svg>
);

const socials = [
    {
        name: "Instagram",
        href: "https://www.instagram.com/sinadicciones_org/",
        Icon: Instagram,
    },
    {
        name: "Facebook",
        href: "https://web.facebook.com/profile.php?id=61585407995202",
        Icon: Facebook,
    },
    {
        name: "TikTok",
        href: "https://www.tiktok.com/@sinadicciones.org",
        Icon: TikTokIcon,
    },
    {
        name: "YouTube",
        href: "https://www.youtube.com/@sinadicciones_org",
        Icon: Youtube,
    },
];

export default function SocialLinks({ variant = "footer" }) {
    const isLarge = variant === "large";
    return (
        <div
            className={`flex items-center ${isLarge ? "gap-3" : "gap-2"}`}
            data-testid="social-links"
        >
            {socials.map(({ name, href, Icon }) => (
                <a
                    key={name}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`SinAdicciones.org en ${name}`}
                    title={name}
                    data-testid={`social-link-${name.toLowerCase()}`}
                    className={`group inline-flex items-center justify-center rounded-full border border-slate-800 bg-slate-900 text-slate-300 transition-all hover:border-cyan-500/50 hover:bg-cyan-500/10 hover:text-cyan-400 hover:-translate-y-0.5 ${
                        isLarge ? "h-11 w-11" : "h-9 w-9"
                    }`}
                >
                    <Icon className={isLarge ? "h-5 w-5" : "h-4 w-4"} />
                </a>
            ))}
        </div>
    );
}
